import React, { memo } from 'react';
import { MessageSquare } from 'lucide-react';
import { PaneShell, PaneEmpty, PaneLink } from './PaneShell';

/**
 * ChatsPane — recent conversations.
 *
 * The one pane still fed by `dashboard`, because chat sessions aren't in the
 * shared project context. That endpoint needs an authenticated project id, so
 * Home hides this pane entirely on share links rather than rendering a box that
 * is permanently and inexplicably empty.
 */

function ChatsPaneImpl({ chats, onOpenChat, onOpenAll }) {
    return (
        <PaneShell
            icon={MessageSquare}
            label="Chats"
            count={chats.length}
            accent="text-primary"
            action={<PaneLink onClick={onOpenAll}>All</PaneLink>}
        >
            {chats.length === 0 ? (
                <PaneEmpty icon={MessageSquare} title="No conversations yet" />
            ) : (
                <div className="cv-auto divide-y divide-white/[0.04]">
                    {chats.map((chat) => (
                        <button
                            key={chat.id}
                            type="button"
                            onClick={() => onOpenChat(chat.id)}
                            className="group flex w-full items-center gap-2.5 px-3 py-2 text-left transition-colors hover:bg-white/[0.03]"
                        >
                            <span className="min-w-0 flex-1 truncate text-xs transition-colors group-hover:text-primary">
                                {chat.title}
                            </span>
                            <span className="flex-shrink-0 whitespace-nowrap text-[10px] tabular-nums text-muted-foreground/70">
                                {chat.message_count}
                            </span>
                        </button>
                    ))}
                </div>
            )}
        </PaneShell>
    );
}

export const ChatsPane = memo(ChatsPaneImpl);
export default ChatsPane;
